<script setup>
defineProps({
  items: {
    type: Array,
    default: () => [],
  },
});

const formatDateTime = (value) => {
  if (!value) return "-";
  const safe = value.replace(" ", "T");
  return new Intl.DateTimeFormat("th-TH", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(new Date(safe));
};
</script>
<template>
  <div class="card border-0 shadow-sm rounded-4 h-100">
    <div class="card-body p-4">
      <div class="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h5 class="fw-bold mb-1">ลำดับเหตุการณ์</h5>
          <div class="text-muted small">
            ประวัติการสร้าง ตรวจสอบ และยืนยันรายการ
          </div>
        </div>
        <span
          class="badge text-bg-light border text-dark rounded-pill px-3 py-2"
        >
          {{ items.length }} เหตุการณ์
        </span>
      </div>

      <div v-if="items.length" class="timeline">
        <div v-for="item in items" :key="item.id" class="timeline-item">
          <div class="timeline-dot"></div>
          <div class="timeline-content">
            <div class="small text-muted mb-1">
              {{ formatDateTime(item.time) }}
            </div>
            <div class="fw-semibold mb-1">{{ item.title }}</div>
            <div class="text-muted small">{{ item.description }}</div>
          </div>
        </div>
      </div>

      <div v-else class="text-center py-5 text-muted">
        <i class="bi bi-clock-history fs-2 d-block mb-2"></i>
        ยังไม่มีลำดับเหตุการณ์ของรายการนี้
      </div>
    </div>
  </div>
</template>

<style scoped>
.timeline {
  position: relative;
  padding-left: 1rem;
}

.timeline::before {
  content: "";
  position: absolute;
  left: 0.3rem;
  top: 0.25rem;
  bottom: 0.25rem;
  width: 2px;
  background: #dee2e6;
}

.timeline-item {
  position: relative;
  padding-left: 1.5rem;
  margin-bottom: 1.5rem;
}

.timeline-item:last-child {
  margin-bottom: 0;
}

.timeline-dot {
  position: absolute;
  left: -0.02rem;
  top: 0.2rem;
  width: 0.75rem;
  height: 0.75rem;
  border-radius: 999px;
  background: #0d6efd;
  border: 2px solid #fff;
  box-shadow: 0 0 0 2px #dee2e6;
}
</style>
